import {Component} from '@angular/core';
import {StyledAbstractIconButtonComponent} from "../../core/icon-styled-button/styled-abstract-icon-button.component";
import { IconButtonBaseComponent } from '../../core/icon-button-base/icon-button-base.component';

@Component({
    selector: 'app-icon-button-orange',
    templateUrl: './icon-button-orange.component.html',
    imports: [IconButtonBaseComponent]
})
export class IconButtonOrangeComponent extends StyledAbstractIconButtonComponent {

}

